export const themes = [
	{
		background: 'from-[#2F2884] via-[#5B2393] to-[#9A1453] text-surface', // Default 0
		border: 'border-[#5B2393]/60' // Lighter purple
	},
	{
		background: 'from-[#581C87] via-[#9B1B30] to-[#F87171] text-surface', // Purple to Red 1
		border: 'border-[#9B1B30]/60' // Red
	},
	{
		background: 'from-[#19173A] via-[#4B5563] to-[#571B8A] text-surface', // Light mode 2
		border: 'border-[#4B5563]/60' // Gray-ish
	},
	{
		background: 'from-[#1A1A1A] via-[#4B5563] to-[#333333] text-surface', // Dark mode 3
		border: 'border-[#4B5563]/40' // Lighter gray
	},
	{
		background: 'from-[#795548] to-[#4D4E43 text-surface', // Brown tones 4
		border: 'border-[#795548]/40' // Brown
	},
	{
		background: 'from-[#607D8B] to-[#38305C] text-surface', // Gray tones 5
		border: 'border-[#607D8B]/50' // Blue Gray
	},
	{
		background: 'from-[#370A57] via-[#5F4081] to-[#1F2175] text-surface', // Indigo tones 6
		border: 'border-[#5F4081]/60' // Lighter Indigo
	},
	{
		background: 'from-[#0F172A] via-[#0871B2] to-[#22C55E] text-surface ', // Red tones 7
		border: 'border-[#0871B2]/50' // Blue
	},
	{
		background: 'from-[#112244] via-[#445577] to-[#112244] text-surface', // Blue tones 8
		border: 'border-[#445577]/50' // Lighter Blue
	},

	// Legacy = 9
	{
		background:
			'from-[#FFFFFF] via-[#FFFFFF] to-[#FFFFFF] dark:from-[#000000] dark:via-[#000000] dark:to-[#000000] text-surface-on dark:text-surface-dark-on', // White to Black 9
		border: 'border-surface/20'
	},

	// Tooling colors
	{
		background: 'from-tooling-0-from to-tooling-0-to text-surface bg-linear-to-r!', // Tooling 10
		border: 'border-tooling-0-from/80'
	},
	{
		background: 'from-tooling-1-from to-tooling-1-to text-surface bg-linear-to-r!', // Tooling 11
		border: 'border-tooling-1-from/80'
	},
	{
		background: 'from-tooling-2-from to-tooling-2-to text-surface bg-linear-to-r!', // Tooling 12
		border: 'border-tooling-2-from/80'
	},
	{
		background: 'from-tooling-3-from to-tooling-3-to text-surface bg-linear-to-r!', // Tooling 13
		border: 'border-tooling-3-from/80'
	},
	{
		background: 'from-tooling-4-from to-tooling-4-to text-surface bg-linear-to-r!', // Tooling 14
		border: 'border-tooling-4-from/80'
	},
	{
		background: 'from-tooling-5-from to-tooling-5-to text-surface bg-linear-to-r!', // Tooling 15
		border: 'border-tooling-5-from/80'
	},
	{
		background: 'from-tooling-6-from to-tooling-6-to text-surface bg-linear-to-r!', // Tooling 16
		border: 'border-tooling-6-from/80'
	},
	{
		background: 'from-tooling-7-from to-tooling-7-to text-surface bg-linear-to-r!', // Tooling 17
		border: 'border-tooling-7-from/80'
	},
	{
		background: 'from-tooling-8-from to-tooling-8-to text-surface bg-linear-to-r!', // Tooling 18
		border: 'border-tooling-8-from/80'
	},
	{
		background: 'from-tooling-9-from to-tooling-9-to text-surface bg-linear-to-r!', // Tooling 19
		border: 'border-tooling-9-from/80'
	},
	{
		background: 'from-tooling-10-from to-tooling-10-to text-surface bg-linear-to-r!', // Tooling 20
		border: 'border-tooling-10-from/80'
	},
	{
		background: 'from-tooling-11-from to-tooling-11-to text-surface bg-linear-to-r!', // Tooling 21
		border: 'border-tooling-11-from/80'
	},
	{
		background: 'from-tooling-12-from to-tooling-12-to text-surface bg-linear-to-r!', // Tooling 22
		border: 'border-tooling-12-from/80'
	},

	{
		background: 'bg-surface/10 dark:bg-surface/5', // surface 23
		border: 'border-surface/20'
	},
	{
		background: 'bg-surface-on text-surface dark:text-surface/80', // surface 24
		border: 'border-surface-on/20'
	},
	{
		background: 'from-[#222222] via-[#999999] to-[#222222] text-surface', // Dark mode 25
		border: 'border-[#999999]/40' // Lighter gray
	}
];
